import type { AcademyRole, StaffSession } from '../types/academyHub'

export interface RosterLearner {
  name: string
  email: string
  country: string
  organisation: string
  role: AcademyRole
  joined: string
  lastActive: string
  /** Course slug to percent complete. */
  enrolled: Record<string, number>
}

/** Sample roster shown in the admin screens until the Academy server is connected. */
export const SAMPLE_ROSTER: RosterLearner[] = [
  { name: 'Jean-Paul Niyonzima', email: 'jp.niyonzima@minecofin.gov.rw', country: 'Rwanda', organisation: 'Ministry of Finance', role: 'learner', joined: '2026-09-02', lastActive: '2026-10-11', enrolled: { 'digital-government-delivery': 67, 'data-driven-decision-making': 100 } },
  { name: 'Grace Okafor', email: 'grace.okafor@hopeworks.ng', country: 'Nigeria', organisation: 'HopeWorks', role: 'learner', joined: '2026-09-05', lastActive: '2026-10-12', enrolled: { 'data-driven-decision-making': 80, 'research-frameworks-policy-investment': 20 } },
  { name: 'Wanjiru Kamau', email: 'wkamau@tunzanet.org', country: 'Kenya', organisation: 'Tunza Network', role: 'learner', joined: '2026-09-09', lastActive: '2026-10-09', enrolled: { 'ai-readiness-five-dimensions': 57 } },
  { name: 'Kofi Asante', email: 'kofi.asante@ghbank.com.gh', country: 'Ghana', organisation: 'Gold Coast Bank', role: 'learner', joined: '2026-09-12', lastActive: '2026-10-10', enrolled: { 'data-driven-decision-making': 40, 'market-evidence-competitive-intelligence': 0 } },
  { name: 'Amina Diallo', email: 'a.diallo@ansd.sn', country: 'Senegal', organisation: 'ANSD', role: 'moderator', joined: '2026-09-01', lastActive: '2026-10-12', enrolled: { 'data-driven-decision-making': 100, 'development-finance-intelligence': 50 } },
  { name: 'Samuel Tesfaye', email: 'samuel.t@moh.gov.et', country: 'Ethiopia', organisation: 'Ministry of Health', role: 'learner', joined: '2026-09-15', lastActive: '2026-10-07', enrolled: { 'applied-ml-non-technical-leaders': 60 } },
  { name: 'Fatou Sowe', email: 'fsowe@opd.gov.gm', country: 'The Gambia', organisation: 'Office of the President', role: 'learner', joined: '2026-09-18', lastActive: '2026-10-06', enrolled: { 'digital-government-delivery': 100, 'development-finance-intelligence': 17 } },
  { name: 'Thandiwe Mokoena', email: 'thandi@agrilink.co.za', country: 'South Africa', organisation: 'AgriLink', role: 'learner', joined: '2026-09-22', lastActive: '2026-10-02', enrolled: { 'go-to-market-emerging-markets': 33 } },
  { name: 'Moses Banda', email: 'moses.banda@mof.gov.zm', country: 'Zambia', organisation: 'Ministry of Finance', role: 'learner', joined: '2026-09-26', lastActive: '2026-09-30', enrolled: { 'development-finance-intelligence': 0 } },
  { name: 'Clarke', email: 'clarke@cavalladata.com', country: 'Rwanda', organisation: 'Cavalla Solution', role: 'admin', joined: '2026-08-20', lastActive: '2026-10-12', enrolled: {} },
  { name: 'Course instructor', email: 'instructor@cavalladata.com', country: 'Rwanda', organisation: 'Cavalla Solution', role: 'instructor', joined: '2026-08-24', lastActive: '2026-10-11', enrolled: {} },
]

/**
 * Prototype staff access. Learners can never reach the admin area: only these accounts, with the shared
 * access code, can sign in. The production Academy replaces this with server-side roles (see the platform spec),
 * because any code shipped to the browser can be read by a determined visitor.
 */
export const STAFF_ACCOUNTS: StaffSession[] = [
  { name: 'Clarke', email: 'clarke@cavalladata.com', role: 'admin' },
  { name: 'Cavalla Academy', email: 'hello@cavalladata.com', role: 'admin' },
  { name: 'Course instructor', email: 'instructor@cavalladata.com', role: 'instructor' },
  { name: 'Amina Diallo', email: 'a.diallo@ansd.sn', role: 'moderator' },
]

export const STAFF_ACCESS_CODE = 'CAVALLA-ACADEMY-2026'

export const ROLE_LABELS: Record<StaffSession['role'], string> = {
  admin: 'Platform admin',
  instructor: 'Instructor',
  moderator: 'Moderator',
}

/** Weekly new enrolments, oldest first, for the last twelve weeks. */
export const SAMPLE_WEEKLY_ENROLMENTS = [4, 7, 6, 11, 9, 14, 18, 16, 22, 27, 25, 31]
